import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';

import MaterialTooltip from './Tooltip';

const useStyles = makeStyles((theme) => ({
  fieldLabel: {
    paddingBottom: '0 !important',
  },
  fieldControl: {
    paddingTop: '0 !important',
  },
  fieldLabelOptional: {
    color: theme.palette.common.grey,
  },
}));

const FormItem = ({ label, tooltip, optional, children, ...other }) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Grid item xs={12} className={classes.fieldLabel}>
        <Typography variant="subtitle1" component="label">
          {label}
        </Typography>{' '}
        {tooltip && <MaterialTooltip tip={tooltip} />}{' '}
        {optional && (
          <Typography variant="subtitle2" component="label" className={classes.fieldLabelOptional}>
            (optional)
          </Typography>
        )}
      </Grid>
      <Grid item xs={12} className={classes.fieldControl} {...other}>
        {children}
      </Grid>
    </Fragment>
  );
};

FormItem.propTypes = {
  label: PropTypes.string,
  tooltip: PropTypes.string,
  optional: PropTypes.bool,
  children: PropTypes.object.isRequired,
  other: PropTypes.object,
};

FormItem.defaultProps = {
  tooltip: null,
  label: null,
  optional: false,
  other: null,
};

export default FormItem;
